module.exports = __webpack_public_path__ + "img/1.59e98d9d.jpg";